export default "__VITE_ASSET__Kc98NpNw__"